import React, { useState } from 'react';
import product from 'data/can-store/product';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

function ModernProductViewer(): JSX.Element {
	const [selectedImageIndex, setSelectedImageIndex] = useState<number>(0);

	// Todo: Implement the component for display no images
	if (!product.images?.length) {
		return <p>No images available</p>;
	}

	return (
		<Box component="section" sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
			<Box
				component="img"
				src={product.images[selectedImageIndex]}
				alt={product.title}
				loading="lazy"
				sx={{ width: '375px', height: '375px', borderRadius: '15px' }}
			/>
			<Stack direction="row" justifyContent="center" spacing={1} sx={{ maxWidth: '375px' }}>
				{product.images.map((image: string, index: number) => (
					<Box
						key={index}
						component="img"
						src={image}
						alt={product.title}
						loading="lazy"
						onClick={() => setSelectedImageIndex(index)}
						sx={{
							width: '80px',
							height: '80px',
							border: `solid 2px ${
								selectedImageIndex === index ? 'var(--csmd-cl-primary-main)' : 'none'
							}`,
							borderRadius: '15px',
							cursor: 'pointer',
						}}
					/>
				))}
			</Stack>
		</Box>
	);
}

export default ModernProductViewer;
